import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Label } from 'reactstrap';
import { checkNullValue, formattedDateAsUTC } from '../utils/Util';
import { AssignedEmpColumnHeader } from '../pages/create-activity/activityHelper';
import '../assets/style/MarketingActivity.css';
import { Image } from 'react-bootstrap';
import { LocationFilterInitialState, LoggedUserType } from '../utils/Types';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import {
  fetchVillagesOfDistricts,
  locationFilterSelector,
} from '../features/locationFilterSlice';
import KTable from './KTable';
import ImagePreviewModal from '../pages/modals/ImagePreviewModal';
import { loginSelector } from '../features/loginSlice';
import { ROLE_OMDC } from '../utils/RBAC';

interface IActivityDetailsProps {
  activity: any;
}

const ViewMarketingActivity: React.FunctionComponent<IActivityDetailsProps> = ({
  activity,
}) => {
  const locationData: LocationFilterInitialState = useAppSelector(
    locationFilterSelector
  );
  const [openImagePreview, setOpenImagePreview] = useState<boolean>(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string>('');
  const dispatch = useAppDispatch();
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const isOMDCUser = ROLE_OMDC.includes(user?.roleId);
  console.log('omdc user', isOMDCUser);

  useEffect(() => {
    if (activity?.employeeList?.length) {
      const districtIds: number[] = Array.from(
        new Set(
          activity.employeeList.map((employee: any) =>
            Number(employee.district)
          )
        )
      );
      const existingDistrictVillages = Object.keys(
        locationData.cityOptions
      ).map((key) => Number(key));
      const districtsWithNoVillages = districtIds.filter(
        (id) => !existingDistrictVillages.includes(id)
      );
      if (districtsWithNoVillages.length) {
        dispatch(
          fetchVillagesOfDistricts({
            districtId: districtsWithNoVillages,
          })
        );
      }
    }
  }, [activity?.employeeList]);

  const handleSelectedImage = (image: any) => {
    setSelectedImageUrl(image.filePath);
    setOpenImagePreview(true);
  };

  const toggleImageModal = () => {
    setOpenImagePreview(false);
    setSelectedImageUrl('');
  };

  const getDetails = () => (
    <div className="mt-4 mx-4">
      <Row>
        <Col xs={12} md={12}>
          <Label className="mb-0 model-label-name">Sales ID</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.activityUniqueId)}
          </Label>
        </Col>
      </Row>
      <Row className="mt-4">
        <Label for="assignees" className="header-style">
          Assigned To
        </Label>
        <KTable
          data={activity?.employeeList ?? []}
          tableParentClass=""
          columnHeader={AssignedEmpColumnHeader}
          locationData={locationData}
          onAction={() => {}}
          isLoading={false}
          showNoDataFoundMsg={false}
        />
      </Row>
      <Row className="mt-1">
        <Label for="marketingActivity" className="header-style mb-1">
          Sales Activity
        </Label>
        <Col xs={12} md={6}>
          <Label className="mb-0 model-label-name">
            Type of Sales Activity
          </Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.activityTypeName)}
          </Label>
        </Col>
        <Col xs={12} md={6}>
          <Label className="mb-0 model-label-name">Activity Date & Time</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {formattedDateAsUTC(
              activity?.activityStartDate,
              'DD-MM-YYYY hh:mm A'
            )}
          </Label>
        </Col>
      </Row>
      <Row className="mt-4">
        <Label for="locationDetails" className="header-style mb-1">
          Location Details
        </Label>
        <Col xs={6} md={3} lg={2}>
          <Label className="mb-0 model-label-name">Zone</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.zoneName)}
          </Label>
        </Col>
        <Col xs={6} md={3} lg={2}>
          <Label className="mb-0 model-label-name">State</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.stateName)}
          </Label>
        </Col>
        <Col xs={6} md={3} lg={3}>
          <Label className="mb-0 model-label-name">District</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.districtName)}
          </Label>
        </Col>
        <Col xs={6} md={3} lg={3}>
          <Label className="mb-0 model-label-name">
            City / Mandal / Village
          </Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.cityName)}
          </Label>
        </Col>
        <Col xs={6} md={3} lg={2}>
          <Label className="mb-0 model-label-name">Pincode</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(activity?.pincode)}
          </Label>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12} md={6} xl={3}>
          <div className="visitorsCard countCard">
            <p className="cardHeading">
              No. of Visitors{''}
              <span className="cardContent">{activity?.countWalkin}</span>
            </p>
          </div>
        </Col>
        {!isOMDCUser && (
          <Col xs={12} md={6} xl={3}>
            <div className="leadsCard countCard">
              <p className="cardHeading">
                Total Leads Created{''}
                <span className="cardContent">{activity?.countLead}</span>
              </p>
            </div>
          </Col>
        )}
        <Col xs={12} md={6} xl={3}>
          <div className="registeredCard countCard">
            <p className="cardHeading">
              Total Farmers Registered{''}
              <span className="cardContent ">
                {activity?.countAppRegistration}
              </span>
            </p>
          </div>
        </Col>
        {!isOMDCUser && (
          <Col xs={12} md={6} xl={3}>
            <div className="complaintsCard countCard">
              <p className="cardHeading">
                Total Complaints Raised{''}
                <span className="cardContent">{activity?.countComplaint}</span>
              </p>
            </div>
          </Col>
        )}
      </Row>
      {activity?.images.length ? (
        <Row className="mt-2">
          <Label for="images" className="header-style">
            Images
          </Label>

          {activity.images.map((image: any, index: number) => (
            <Col
              xs={12}
              md={6}
              xl={3}
              key={`key-${String(index)}}`}
              className="mt-3"
            >
              <Image
                src={image?.filePath}
                width={'100%'}
                height={'200px'}
                className="activityImage"
                alt="activity image"
                onClick={() => handleSelectedImage(image)}
              />
            </Col>
          ))}
        </Row>
      ) : (
        ''
      )}
      <ImagePreviewModal
        isItUrl={true}
        isOpen={openImagePreview}
        onApproveRejectAction={(actionType: number, documentId: number) => {}}
        photoURL={selectedImageUrl}
        toggle={toggleImageModal}
      />
    </div>
  );
  return getDetails();
};

export default ViewMarketingActivity;
